
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/[locale]",
      function () {
        return require("private-next-pages/sitemap/[locale].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/[locale]"])
      });
    }
  